// PATH: src/components/settings/useEmbedPrompts.ts
import * as React from "react";
import { useAppConfigsApi } from "../../api";
import type { FactPromptsResponse } from "../../models/domain";
import { errorMessage } from "../ui";

/**
 * Les prompts de base des objectifs et des faits (`GET /v1/llm-settings/prompts`).
 * Ils éclairent un réglage sans le conditionner : une panne s'affiche à leur
 * place et n'empêche ni d'enregistrer ni de lancer un essai.
 */
export const useEmbedPrompts = () => {
  const { getFactPrompts } = useAppConfigsApi();
  const [prompts, setPrompts] = React.useState<FactPromptsResponse | null>(null);
  const [error, setError] = React.useState<string | null>(null);
  React.useEffect(() => {
    getFactPrompts()
      .then(({ data }) => setPrompts(data))
      .catch((e) => setError(errorMessage(e, "Prompts des objectifs et des faits indisponibles (tc_embed_be).")));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return { prompts, error };
};
